import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

const ERR_HUMAN = {
  invalid_state: 'The bank link expired before you returned. Please open StreakFree and try connecting again.',
  expired: 'Authorisation expired. Please open StreakFree and retry the connection.',
  access_denied: 'You cancelled the connection at your bank.',
  missing_params: 'The bank did not send back the expected details. Please try again.',
};

export default function BankConnectedPage() {
  const params = new URLSearchParams(window.location.search);
  const ok = params.get('bank_connected') === 'true';
  const err = params.get('bank_error');

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-6" data-testid="bank-connected-page">
      <div className="max-w-sm w-full bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center">
        {ok ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Bank connected</h1>
            <p className="text-sm text-zinc-400 mb-6">
              Your bank feed is live. You can close this tab and go back to the StreakFree app — no need to log in here.
            </p>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Connection didn't complete</h1>
            <p className="text-sm text-zinc-400 mb-6" data-testid="bank-connect-error">
              {ERR_HUMAN[err] || `Bank connection failed${err ? `: ${err}` : ''}. Please open StreakFree and try again.`}
            </p>
          </>
        )}
        <a
          href="/"
          className="inline-block w-full py-3 rounded-xl bg-orange-500 text-white font-semibold text-sm"
          data-testid="open-streakfree-btn"
        >
          Open StreakFree
        </a>
      </div>
    </div>
  );
}
